import React from 'react';
import { FaHandsHelping, FaSmile, FaExchangeAlt, FaLightbulb } from 'react-icons/fa';

const tarofExamples = [
  {
    title: 'Offering Food or Drink',
    example: 'بفرمایید چای! (Befarmaid chay!) — Please have some tea! (even if you don’t expect them to accept right away)'
  },
  {
    title: 'Refusing Payment',
    example: 'قابلی نداره! (Ghabeli nadare!) — It’s nothing! (when someone tries to pay you for something)'
  },
  {
    title: 'Insisting on Hospitality',
    example: 'خواهش می‌کنم، مهمان مایید! (Khaahesh mikonam, mehman maaeed!) — Please, you are our guest!'
  },
  {
    title: 'Polite Refusal',
    example: 'زحمت نکشید! (Zahmat nakeshid!) — Don’t trouble yourself! (when someone offers you something)'
  }
];

const TarofTips: React.FC = () => (
  <div className="max-w-3xl mx-auto py-12 px-4">
    <div className="flex items-center justify-center mb-6">
      <FaHandsHelping className="text-4xl text-orange-500 mr-3" />
      <h1 className="text-4xl font-bold text-gray-900 dark:text-white">Ta'arof Tips</h1>
    </div>
    <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4 text-center">Understanding Persian Politeness</h2>
    <p className="text-lg text-gray-700 dark:text-gray-300 mb-8 text-center leading-relaxed">
      <strong>Ta'arof</strong> (تعارف) is a unique aspect of Persian culture involving polite gestures, offers, and refusals. It’s about showing respect, hospitality, and humility—even if you don’t mean every offer literally! Here are some tips and examples to help you navigate ta'arof like a pro.
    </p>
    <div className="grid md:grid-cols-2 gap-6 mb-10">
      {tarofExamples.map((item, idx) => (
        <div key={idx} className="bg-white dark:bg-gray-800 rounded-xl shadow p-6">
          <div className="flex items-center mb-2">
            <FaSmile className="text-xl text-orange-400 mr-2" />
            <h3 className="text-lg font-bold text-gray-900 dark:text-white">{item.title}</h3>
          </div>
          <p className="text-gray-700 dark:text-gray-300">{item.example}</p>
        </div>
      ))}
    </div>
    <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6 mb-8">
      <div className="flex items-center mb-2">
        <FaExchangeAlt className="text-xl text-blue-500 mr-2" />
        <h3 className="text-lg font-bold text-blue-700 dark:text-blue-200">How to Respond to Ta'arof</h3>
      </div>
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 bg-blue-100 dark:bg-blue-800/40 rounded-lg p-4 text-gray-700 dark:text-gray-300 text-center">
          If someone offers you something, politely refuse once or twice before accepting (if you want it).
        </div>
        <div className="flex-1 bg-blue-100 dark:bg-blue-800/40 rounded-lg p-4 text-gray-700 dark:text-gray-300 text-center">
          If you’re not sure if an offer is genuine, watch for insistence—if they insist, it’s probably real!
        </div>
        <div className="flex-1 bg-blue-100 dark:bg-blue-800/40 rounded-lg p-4 text-gray-700 dark:text-gray-300 text-center">
          It’s okay to say “Thank you, but I really can’t” if you don’t want to accept.
        </div>
      </div>
    </div>
    <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-xl p-6">
      <div className="flex items-center mb-2">
        <FaLightbulb className="text-xl text-yellow-500 mr-2" />
        <h3 className="text-lg font-bold text-yellow-700 dark:text-yellow-200">Quick Tips</h3>
      </div>
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 bg-yellow-100 dark:bg-yellow-800/40 rounded-lg p-4 text-gray-700 dark:text-gray-300 text-center">
          Don’t take the first “No, thank you” at face value—offer again!
        </div>
        <div className="flex-1 bg-yellow-100 dark:bg-yellow-800/40 rounded-lg p-4 text-gray-700 dark:text-gray-300 text-center">
          When in doubt, smile and be extra polite. Iranians appreciate the effort.
        </div>
        <div className="flex-1 bg-yellow-100 dark:bg-yellow-800/40 rounded-lg p-4 text-gray-700 dark:text-gray-300 text-center">
          Ta'arof is about kindness and respect, not trickery. Enjoy the ritual!
        </div>
      </div>
    </div>
  </div>
);

export default TarofTips; 